// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Typography } from "@mui/material";

// COMPONENTS

// ASSETS
import { ClientAccountNameProps } from "./types";
import { MultiAccountListStyles } from "./index.styles";

const ClientAccountName = (props: ClientAccountNameProps) => {
  const classes = MultiAccountListStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.primaryText}>{props.primaryText}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.secondaryText}>{props.secondaryText}</Typography>
      </Grid>
    </Grid>
  );
};

export default ClientAccountName;
